import { render, staticRenderFns } from "./RejectOrderModal.vue?vue&type=template&id=c7287c48&scoped=true&"
import script from "./RejectOrderModal.vue?vue&type=script&lang=js&"
export * from "./RejectOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./RejectOrderModal.vue?vue&type=style&index=0&id=c7287c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7287c48",
  null
  
)

export default component.exports